import {
	AncillaryId,
	IAncillary,
	IAncillaryWithPrice,
} from '../../../../../domain/ancillary/domain/models/IAncillary';
import {
	AncillaryGroupId,
	IAncillaryGroup,
} from '../../../../../domain/ancillary/domain/models/IAncillaryGroup';
import { IAncillaryGroupLevel, IAncillaryLevel } from '../../nested-input';
import { IOption, IOptionGroup } from '../../option';

export function adaptAncillaryGroupToOptionGroup(
	{ id, name, headline, description, ancillaries }: IAncillaryGroup,
	nestedInputLevel: IAncillaryGroupLevel,
): IOptionGroup<AncillaryGroupId, AncillaryId> {
	const options = ancillaries
		.filter(isAncillaryWithPrice)
		.map((ancillary, ancillaryIndex) =>
			adaptAncillaryToOption(ancillary, {
				...nestedInputLevel,
				ancillaryIndex,
			}),
		);

	return {
		id,
		title: name,
		headline,
		moreInformation: description,
		hasMutuallyExclusiveOptions: true,
		options,
		nestedInputLevel,
	};
}

function adaptAncillaryToOption(
	{ id, name, price }: IAncillaryWithPrice,
	nestedInputLevel: IAncillaryLevel,
): IOption<AncillaryId> {
	return {
		id,
		label: name,
		nestedInputLevel,
		price,
	};
}

function isAncillaryWithPrice(
	ancillary: IAncillary,
): ancillary is IAncillaryWithPrice {
	return !!ancillary.price;
}
